import yandex from '../images/yandex_page-0002.jpg';
import rs from '../images/rs.jpg';

export const EduEng = [
    {
        Name: 'Saint Petersburg College of Management and\u00A0Commerce',
        Age: '2013',
        Profile: 'Servicing computer equipment and\u00A0computer networks',
    },
    {
        Name: 'Saint Petersburg State Technological Institute (Technical\u00A0University)',
        Age: '2018',
        Profile: 'Management, Logistics',
    },
    {
        Name: 'RS School',
        Age: '2023',
        Profile: 'Front-end developer',
        Image: rs,
    },
    {
        Name: 'Yandex.Practicum',
        Age: '2023',
        Profile: 'Web developer',
        Image: yandex,
    }
]
export const EduRu = [
    {
        Name: 'Санкт–Петербургский Технический колледж управления и коммерции',
        Age: '2013',
        Profile: 'Обслуживание вычислительной техники и компьютерных сетей',
    },
    {
        Name: 'Санкт-Петербургский технологический институт(университет)',
        Age: '2018',
        Profile: 'Менеджмент, Логистика',
    },
    {
        Name: 'RS School',
        Age: '2023',
        Profile: 'Front-end developer',
        Image: rs,
    },
    {
        Name: 'Яндекс.Практикум',
        Age: '2023',
        Profile: 'Веб разработка',
        Image: yandex,
    }
]